<template>
  <div :class="s.character_select" role="radiogroup" aria-label="推しキャラクターを選択">
    <div :class="s.characters">
      <div
        v-for="(character, index) in characters"
        :key="character.id"
        :class="s.character_wrapper"
      >
        <button
          type="button"
          role="radio"
          :aria-checked="modelValue === character.name ? 'true' : 'false'"
          :aria-label="`${character.name}を選択`"
          :class="[s.character, modelValue === character.name ? s.active : '']"
          @click="selectCharacter(character.name)"
        >
          <img
            :src="`/img/pages/enquete/c-${index + 1}.png`"
            :class="s.character_icon"
            alt=""
          >
          <!--
          <img
            :src="`/img/pages/enquete/a${index + 1}.svg`"
            :class="s.icon"
            alt=""
          >
          <span :class="s.name">{{ character.name }}</span>
          <div :class="s.image_wrapper">
            <img
              :src="`/img/pages/enquete/c${index + 1}.png`"
              :alt="character.name"
              :class="[s.image, s[`c${index + 1}`]]"
              loading="lazy"
            />
          </div>
          -->
        </button>
      </div>
    </div>

    <!-- hidden input for Google Form -->
    <input
      type="hidden"
      :name="entryId"
      :value="modelValue"
    />
  </div>
</template>

<script>
export default {
  name: 'CharacterButtons',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    entryId: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      characters: [
        {
          id: 'sensaichijiku',
          name: 'せんさイチジク',
        },
        {
          id: 'chiekeradeisshu',
          name: 'チェケラディッシュ',
        },
        {
          id: 'cospapurika',
          name: 'コスパプリカ',
        },
        {
          id: 'sanzaingen',
          name: 'さんざインゲン',
        },
        {
          id: 'kenkiwi',
          name: 'けんキウイ',
        },
        {
          id: 'ganbarucola',
          name: 'がんばルッコラ',
        },
        {
          id: 'misterikorisu',
          name: 'ミステリコリス',
        },
        {
          id: 'seebon',
          name: 'シーボン',
        },
      ],
    };
  },
  methods: {
    selectCharacter(name) {
      this.$emit('update:modelValue', name);
    },
  },
};
</script>

<style lang="scss" module="s">
@import "@/assets/scss/_mq.scss";

.character_select {
  width: 100%;
  margin-top: 80px;

}

.characters {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 36px 24px;

  &::before {
    content: '';
    width: 3px;
    height: 3px;
  }
}

.character_wrapper {
  position: relative;
  width: calc((100% - 24px * 2) / 3);
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: #fff;
    border: 3px solid #000;
    border-radius: 43px;
    translate: 11px 13px;
    transition: all 0.2s ease;
    background: var(--primary-color, #4CAF50) url(/img/pages/choikulove/bg-dot.svg) repeat;
    background-size: 10px;
  }

  &:active::before {
    translate: 0 0;
  }
}

.character {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: #fff;
  border: 3px solid #000;
  border-radius: 43px;
  cursor: pointer;
  transition: all 100ms ease;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  padding: 20px;

  &:hover {
    translate: 0 -5px;
  }

  &:active {
    translate: 0 0;
  }

  &.active {
    background-color: var(--primary-color, #4CAF50);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.3);
  }
}

.character_icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image_wrapper {
  width: 100%;
  height: 100%;
}

// タブレット対応
@include mdView {
  .characters {
    &::before {
      content: none;
    }
  }

  .character_wrapper {
    width: calc(( 100% - 24px ) / 2);
  }
}

// スマートフォン対応
@include smView {
  .character_select {
    margin-top: 30px;
  }

  .characters {
    gap: 18px;
  }

  .character_wrapper {
    &::before {
      border-radius: 30px;
      translate: 8px 9px;
    }

    &:active::before {
      translate: 0 0;
    }
  }

  .character {
    padding: 12px;
    border-radius: 30px;
  }
}

// 小型スマートフォン対応
@include xsView {
  .characters {
    gap: 12px;
  }
}
</style>
